import styled from "styled-components";

export const NoticeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoticeItem = styled.div`
  background: ${props => props.$isRead ? '#ffffff' : '#f0f9ff'};
  border: 1px solid ${props => props.$isRead ? '#e2e8f0' : '#bae6fd'};
  border-left: 4px solid ${props => props.$isRead ? '#cbd5e1' : '#0ea5e9'};
  border-radius: 8px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transform: translateY(-2px);
    border-color: ${props => props.$isRead ? '#cbd5e1' : '#7dd3fc'};
  }
`;

export const NoticeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const NoticeTitle = styled.h4`
  font-size: 16px;
  font-weight: ${props => props.$isRead ? '600' : '700'};
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const NoticeDate = styled.span`
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
`;

export const NoticePreview = styled.p`
  font-size: 14px;
  color: #475569;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
  text-align: center;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }
`;

export const FooterModal = styled.div`
   display: flex;
   width: 100%;
   justify-content: space-between;
   align-items: center;
`;

export const ContainerModal = styled.div`
  font-size: 15px;
  color: #334155;
  line-height: 1.6;
  padding-top: 10px;

`;

export const Span = styled.span`
  font-size: 12px;
  color: #94a3b8;
  margin-top: 10px
`;
